// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"hB-z","smallCardRow":"iB-z","largeCardRow":"jB-z","productSearchRow":"kB-z","curatedRow":"lB-z"};